/* eslint-disable jsx-a11y/alt-text */
import classNames from 'classnames/bind'
import React, { useCallback, useMemo, VFC } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { setPageBanner } from '../../../redux/slices/dashboard'
import { __STORAGE } from '../../../utils/enums'
import { useDangerousHTML, useRenderLink } from '../../../utils/hooks'
import Utils from '../../../utils/utils'
import styles from './account-type-banner.module.scss'
import cross from './cross.svg'

const cx = classNames.bind(styles)

interface AccountTypeBannerProps {

}

const AccountTypeBanner: VFC<AccountTypeBannerProps> = (props) => {
    const dispatch = useDispatch()
    const { t } = useTranslation()
    const { d } = useDangerousHTML()
    const { renderLink } = useRenderLink()
    // const platforms = usePlatforms()
    // const { hasMini } = useAccounts()

    const shouldShow = useMemo(() => {
        return false
        // const mt4 = platforms.find(p => p.name === 'MT4')
        // if (mt4) {
        //     return mt4.accounts.some(a => a.type === 'Classic')
        // }
        // return false
    }, [])

    const close = useCallback(() => {
        dispatch(setPageBanner(null))
        Utils.setStorageBoolean(true, __STORAGE.acTypeShown)
    }, [dispatch])

    return shouldShow && !Utils.getStorageBoolean(__STORAGE.acTypeShown)
        ? (
            <div className={cx('content')}>
                {/* {d(t('common:newAccountTypeBanner.text', { link }))} */}
                {d(t('common:newAccountTypeBanner.text',
                    { link: renderLink('http://google.com', t('common:newAccountTypeBanner.here')) }))}
                <img src={cross} onClick={close} />
            </div>
        ) : null

}

export default AccountTypeBanner